import * as React from 'react';

import { usePropertyListing } from 'src/common/stores/contexts';

import { classNames } from 'uitk-react-utils';
import { UitkHeading } from 'uitk-react-text';

export interface ListingNameProps {
  lineCount?: number;
  visuallyHidden?: boolean;
}

export const ListingName: React.FunctionComponent<ListingNameProps> = ({ lineCount = 1, visuallyHidden = false }) => {
  const { name, recentlyViewed } = usePropertyListing();

  if (visuallyHidden) {
    return (
      <UitkHeading tag="h3" size={5} className="is-visually-hidden">
        {name}
      </UitkHeading>
    );
  }

  const truncateClass = lineCount && lineCount >= 2 && lineCount <= 9 ? `truncate-lines-${lineCount}` : 'truncate';
  const classes = classNames(`${truncateClass} all-b-padding-half`, {
    'uitk-type-500 pwa-theme--grey-700': recentlyViewed,
    'pwa-theme--grey-900 uitk-type-heading-500': !recentlyViewed,
  });

  return (
    <UitkHeading tag="h3" size={5} className={classes} data-stid="content-hotel-title" aria-hidden="true">
      {name}
    </UitkHeading>
  );
};
ListingName.displayName = 'ListingName';
